import { render } from "./CustomerPaymentModal.vue?vue&type=template&id=0b46fc28&scoped=true&ts=true&lang=pug"
import script from "./CustomerPaymentModal.vue?vue&type=script&lang=ts"
export * from "./CustomerPaymentModal.vue?vue&type=script&lang=ts"

import "./CustomerPaymentModal.vue?vue&type=style&index=0&id=0b46fc28&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b46fc28"]])

export default __exports__